/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface CenterUserControllerSearch$Params {

/**
 * 센터 ID
 */
  centerId: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 근무 형태
 */
  workType?: Array<string>;

/**
 * 선생님 ID
 */
  teacherId?: string;

/**
 * 소속 여부
 */
  isAccepted?: string;

/**
 * 사용자 ID
 */
  userId?: string;
}

export function centerUserControllerSearch(http: HttpClient, rootUrl: string, params: CenterUserControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerSearch.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('workType', params.workType, {});
    rb.query('teacherId', params.teacherId, {});
    rb.query('isAccepted', params.isAccepted, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

centerUserControllerSearch.PATH = '/api/center-user/{centerId}/users/search';
